export function pageModel<TPageModel>(id?: string) : TPageModel {
    const element = document.getElementById(id ?? 'page-model');
    const data = element?.textContent!;
    return <TPageModel>JSON.parse(data);
}